import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

import bannerCloud from "../../img/home/banner-cloud.webp";

const CARD_STYLE = {
  backgroundImage: "linear-gradient(90deg, rgba(10,22,40,0.9) 0%, rgba(26,46,74,0.9) 100%)",
  backdropFilter: "blur(16px)",
};

function StatsBlock() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt">
      <div className="glcontainer">
        {/* ── Desktop ── */}
        <Fade triggerOnce direction="up" duration={700} className="hidden lg:block">
        <div className="flex gap-[31px]">
          {/* Левая большая карточка */}
          <div
            className="relative overflow-hidden rounded-[28px] p-[40px] flex flex-col gap-[20px] w-[48.5%] shrink-0"
            style={CARD_STYLE}
          >
            <div className="flex flex-col gap-[12px]">
              <p className="font-['Inter'] font-bold text-[56px] leading-[1.1] text-white">
                {t("trading.stats.line1")}
              </p>
              <p className="font-['Inter'] font-bold text-[56px] leading-[1.1] text-white">
                {t("trading.stats.line2")}
              </p>
            </div>
            <div className="flex items-baseline gap-[12px]">
              <span className="font-64-42">{t("trading.stats.value")}</span>
              <span className="font-['Inter'] font-medium text-[18px] text-[rgba(255,255,255,0.75)]">
                {t("trading.stats.valueLabel")}
              </span>
            </div>
            <a
              href={link}
              className="inline-flex w-fit items-center justify-center px-[42px] py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
              style={{
                backgroundImage:
                  "linear-gradient(-84deg, rgba(255,255,255,0.4) 6%, rgba(204,222,255,0.4) 66%)",
              }}
            >
              {t("trading.stats.cta")}
            </a>
          </div>

          {/* Правые карточки */}
          <div className="flex flex-col gap-[32px] flex-1">
            <div
              className="relative overflow-hidden rounded-[28px] px-[40px] flex items-center h-[166px]"
              style={CARD_STYLE}
            >
              <div className="flex items-baseline gap-[12px] whitespace-nowrap">
                <span className="font-64-42">{t("trading.stats.spreads")}</span>
                <span className="font-['Inter'] font-medium text-[18px] text-[rgba(255,255,255,0.75)] capitalize">
                  {t("trading.stats.spreadsLabel")}
                </span>
              </div>
            </div>
            <div
              className="relative overflow-hidden rounded-[28px] px-[40px] flex items-center h-[166px]"
              style={CARD_STYLE}
            >
              <img
                src={bannerCloud}
                alt=""
                aria-hidden
                className="absolute right-[-20%] top-[-25%] w-[100%] opacity-25 pointer-events-none select-none"
              />
              <div className="relative flex items-baseline gap-[12px] whitespace-nowrap">
                <span className="font-64-42">{t("trading.stats.leverage")}</span>
                <span className="font-['Inter'] font-medium text-[18px] text-[rgba(255,255,255,0.75)] capitalize">
                  {t("trading.stats.leverageLabel")}
                </span>
              </div>
            </div>
          </div>
        </div>
        </Fade>

        {/* ── Mobile / tablet ── */}
        <Fade triggerOnce direction="up" duration={700} className="lg:hidden">
        <div className="flex flex-col gap-[7px]">
          <div
            className="relative overflow-hidden rounded-[20px] px-[15px] py-[20px] flex items-center justify-between gap-[15px]"
            style={CARD_STYLE}
          >
            <img
              src={bannerCloud}
              alt=""
              aria-hidden
              className="absolute left-[-15%] top-[-90%] w-[120%] opacity-25 pointer-events-none select-none"
            />
            <p className="relative font-['Inter'] font-bold text-[28px] leading-[1.3] text-white">
              {t("trading.stats.line1")} {t("trading.stats.line2")}
            </p>
            <div className="relative flex items-baseline gap-[10px] shrink-0">
              <span className="font-['Inter'] font-bold text-[42px] text-white">
                {t("trading.stats.value")}
              </span>
              <span className="font-['Inter'] font-medium text-[14px] text-[rgba(255,255,255,0.75)]">
                {t("trading.stats.valueLabel")}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-[7px]">
            <div
              className="relative overflow-hidden rounded-[20px] px-[15px] py-[20px] flex flex-col gap-[12px]"
              style={CARD_STYLE}
            >
              <span className="font-['Inter'] font-bold text-[42px] leading-none text-white">
                {t("trading.stats.spreads")}
              </span>
              <span className="font-['Inter'] font-medium text-[14px] text-[rgba(255,255,255,0.75)] capitalize">
                {t("trading.stats.spreadsLabel")}
              </span>
            </div>
            <div
              className="relative overflow-hidden rounded-[20px] px-[15px] py-[20px] flex flex-col gap-[12px]"
              style={CARD_STYLE}
            >
              <span className="font-['Inter'] font-bold text-[42px] leading-none text-white">
                {t("trading.stats.leverage")}
              </span>
              <span className="font-['Inter'] font-medium text-[14px] text-[rgba(255,255,255,0.75)] capitalize">
                {t("trading.stats.leverageLabel")}
              </span>
            </div>
          </div>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default StatsBlock;
